import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LyDialog } from '@alyle/ui/dialog';
import { CloudService } from 'app/main/pagina/tools/cloud/cloud.service';
import { DATOS_API } from 'app/auth/auth.datos';
import Swal from 'sweetalert2';
import {TranslateService} from "@ngx-translate/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_editorBroker } from 'app/idiomas/i18n/editor-broker/editor-broker.lang';
import { ModalImgComponent } from "../modal-img/modal-img.component";

@Component({
  selector: 'app-modal-imagen-html',
  templateUrl: './modal-imagen-html.component.html',
  styleUrls: ['./modal-imagen-html.component.scss']
})
export class ModalImagenHtmlComponent implements OnInit {

  arregloImagenes = [
    // { image: 'http://35.247.147.202/surveyadministrator2/cgo5/backend/4fa42aa0ba652605cada43bca0fc6389/brokerAssets/1/es_login_generics_images_login_1620762766691' },
    // { image: 'http://35.247.147.202/surveyadministrator2/cgo5/backend/4fa42aa0ba652605cada43bca0fc6389/brokerAssets/1/es_home_generics_menuBrand_logo_1622216779478' },
    // { image: 'http://35.247.147.202/surveyadministrator2/cgo5/backend/4fa42aa0ba652605cada43bca0fc6389/brokerAssets/1/es_home_generics_branding_image_1620762836380' },
  ];

  urlImagen: string;
  carpetaImagenes: any;
  direccionRaiz = "./4fa42aa0ba652605cada43bca0fc6389/";
  cargandoImagenes = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalImagenHtmlComponent>,
    private dialog: MatDialog,
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private cloudService: CloudService,
  ) {
    lang_editorBroker.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    console.log("datosRecibidos:",this.datos);
    if(this.datos.carpetaBroker != undefined){  //si viene del editor broker
      this.getCarpetaImagenes();
    } else{   //si viene del editor encuesta o editor templates correo
      this.getInfoEmpresa();
    }
  }

  getInfoEmpresa(){
    this.cloudService.getInfoEmpresa(localStorage.getItem('companyID')).subscribe((respuesta:any) => {
      console.log("getInfoEmpresa:",respuesta);
      if(respuesta.message == 'Success'){
        // this.direccionRaiz = this.direccionRaiz + respuesta.data.nombreEmpresa + "/";
        this.direccionRaiz = this.direccionRaiz + localStorage.getItem('companyID') + "/";
        this.getRaiz();
      }
    });
  }

  getRaiz(){
    let idEmpresa = localStorage.getItem('companyID');
    this.cloudService.getCarpetaRaiz(idEmpresa).subscribe( (respuesta:any) => {
      console.log("getRaiz:",respuesta);
      if(respuesta.success){
        if(respuesta.carpetas.length == 0){
          this.guardaCarpeta('editorImages');
        } else{
          // let datosCarpetaImgs = respuesta.carpetas.find(item => item.nombre == 'editorImages');
          let datosCarpetaImgs = respuesta.carpetas.find(item => item.nombre == 'editorImages' && item.ubicacion.includes(localStorage.getItem('companyID')));
          if(datosCarpetaImgs != undefined){
            // this.revisaDirectorios(datosCarpetaImgs);
            this.carpetaImagenes = datosCarpetaImgs;
            this.getImagenesCarpeta();
          } else{
            this.guardaCarpeta('editorImages');
          }
        }
      }
    });
  }

  guardaCarpeta(nombre:string, ubicacion?:string, carpetaAssets?:any){
    let datos:any = {
      nombre: nombre,
      ubicacion: ubicacion != undefined ? ubicacion : this.direccionRaiz,
      empresaId: localStorage.getItem('companyID')
    };
    if(carpetaAssets){
      datos.carpetaId = carpetaAssets._id;  //solo cuando no es la raiz
    }
    console.log(datos);
    this.cloudService.guardaCarpetaITBM(datos).subscribe((respuesta:any) => {
      console.log("guardaCarpetaITBM:",respuesta);
      if(respuesta.success){
        if(nombre == 'editorImages'){
          this.getRaiz();
        }
      }
    }, error => {
      console.log(error);
    });
  }

  getCarpetaImagenes(){
    this.cloudService.getCarpeta(this.datos.carpetaBroker._id).subscribe((respuesta:any) => {
      console.log("getCarpeta:",respuesta);
      if(respuesta.success){
        if(respuesta.subcarpetas.length == 0){  //si el arreglo de subcarpetas esta vacio, crea la carpeta de imagenes
          this.creaSubcarpetaImagenes();
        } else{
          this.carpetaImagenes = respuesta.subcarpetas.find(item => item.nombre == 'editorImages');
          this.getImagenesCarpeta();
        }
      }
    });
  }

  creaSubcarpetaImagenes(){
    let datos: any = {
      nombre: 'editorImages',
      ubicacion: `${this.datos.carpetaBroker.ubicacion}${this.datos.carpetaBroker.nombre}`,
      carpetaId: this.datos.carpetaBroker._id
    };
    console.log("nuevaCarpeta:",datos);
    this.cloudService.guardaCarpetaITBM(datos).subscribe((respuesta:any) => {
      console.log("guardaCarpetaITBM:",respuesta);
      if(respuesta.success){
        this.carpetaImagenes = respuesta.carpeta;
        this.getImagenesCarpeta();
      }
    }, error => {
      console.log(error);
    });
  }

  getImagenesCarpeta(){
    let url = DATOS_API.urlLogos.split(":");
    let htp = DATOS_API.urlLogos.split("/");
    let urlFileManager = DATOS_API.urlFileManager;
    this.cloudService.getCarpeta(this.carpetaImagenes._id).subscribe((respuesta:any) => {
      console.log("getImagenes:",respuesta);
      if(respuesta.success){
        respuesta.archivos.forEach(imagen => {
          let urlImagenCargada = `${htp[0]}${url[1]}${urlFileManager}${imagen.ubicacion.substr(2)}${imagen.nombre}`;
          this.arregloImagenes.push({
            image: urlImagenCargada
          })
        });
        this.cargandoImagenes = false;
      }
    });
  }

  zoomImagen(url:string, opcion:number){
    let tagImagen:string;
    switch (opcion) {
      case 1: //imagen
        tagImagen = `<img src="${url}" alt="" width="100%">`;
      break;
      case 2: //video
        tagImagen = `<video src="${url}" alt="" width="100%" autoplay controls>`;
      break;
    }
    Swal.fire({
      // title: this.translateSrv.instant('EDITOR.ELEMENTOS.GUIA'),
      // html: '<img src="https://www.harley-davidson.com/content/dam/h-d/images/product-images/bikes/motorcycle/2021/2021-sport-glide/2021-sport-glide-f16/2021-sport-glide-f16-motorcycle.jpg" alt="" width="100%">',
      html: tagImagen,

      confirmButtonText: 'OK',
      width: '80%'
    });
  }

  openCropperDialog(event: Event) {
    // this.cropped = null!;
    this._dialog.open<ModalImgComponent, Event>(ModalImgComponent, {
      data: event,
      width: '100%',
      disableClose: true
    // }).afterClosed.subscribe((result?: ImgCropperEvent, objDrop?: any) => {
    }).afterClosed.subscribe((result?: any) => {
      let [resultado,objDrop] = result;
      if (resultado) {
        // this.cropped[`${pagina}_${paso}_${elemento}`] = resultado.dataURL;
        this._cd.markForCheck();
        console.log("resultado:",resultado);
        console.log("objDrop:",objDrop);
        let nomSplit = objDrop.name.split(".");
        fetch(resultado.dataURL)
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            console.log("blob:",blob);
            let nombreArchivo: string = `${Date.now()}.${nomSplit[nomSplit.length - 1]}`;
            let file = new File([blob], nombreArchivo, {type: objDrop.type});
            console.log("file:",file);
            this.guardaImagenCargada(file);
        });
      }
    });
  }

  guardaImagenCargada(archivo:any){
    // let indiceBroker = this.institutos.findIndex(item => item.numInstituto == this.brokerElegido);
    // let carpetaBroker = this.carpetasBrokers[this.institutos[indiceBroker].indiceCarpeta];
    // let ubicacion = `${carpetaBroker.ubicacion}${carpetaBroker.nombre}/`;
    let carpetaBroker = this.carpetaImagenes;
    let ubicacion = `${carpetaBroker.ubicacion}${carpetaBroker.nombre}/`;
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('file',archivo, archivo.name);
    fd.append('ubicacion',ubicacion);
    fd.append('carpetaId',carpetaBroker._id);
    // fd.append('ubicacion',this.direccionRaiz);
    // fd.append('empresaId',this.idEmpresa);
    // console.log(...fd);
    // new Response(fd).text().then(console.log);
    this.cloudService.guardaArchivo(fd).subscribe((res) => {
        // console.log(res)
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          let url = DATOS_API.urlLogos.split(":");
          let htp = DATOS_API.urlLogos.split("/");
          let urlFileManager = DATOS_API.urlFileManager;
          let urlImagenCargada = htp[0] + url[1] + urlFileManager + res.archivo.ubicacion.substr(2) + res.archivo.nombre;
          this.getImagenesCarpeta();
          this.copiarURL(urlImagenCargada);
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
            // this.guardandoArchivo = false;
            // this.progresoCarga = 0;
          }
        }
      },
      (err) => console.log(err)
    );
  }

  copiarURL(url: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: this.translateSrv.instant('EDITOR.ELEMENTOS.MODALIMAGEN.TABS.IMAGENES.URLCOPIADA'),

      confirmButtonText: this.translateSrv.instant('EDITOR.ELEMENTOS.MODALIMAGEN.TABS.IMAGENES.OKBOT'),
    });

  }

  salir(){
    this.dialogRef.close(this.urlImagen);
  }

}
